module.exports = __webpack_public_path__ + "img/ics_o_on_delivery.28cadd1e.svg";